// PDF to JPG (P2J-02): split dropped files into readable ones and ones to report inline.

export const UNREADABLE_PDF_MESSAGE = "This file couldn't be read as a PDF";

export async function partitionReadable(
  files: File[],
  probe: (f: File) => Promise<unknown>,
): Promise<{ ok: File[]; bad: File[] }> {
  const ok: File[] = [];
  const bad: File[] = [];
  for (const f of files) {
    try { await probe(f); ok.push(f); } catch { bad.push(f); }
  }
  return { ok, bad };
}

export function unreadableText(bad: { name: string }[]): string {
  return bad.length === 1 ? `${UNREADABLE_PDF_MESSAGE}: ${bad[0].name}. It may be damaged. Nothing was used.` : `${UNREADABLE_PDF_MESSAGE}: ${bad.map((b) => b.name).join(", ")}. Nothing was used.`;
}
